@import 'styles/mixins';
@import 'styles/variables';

@keyframes loading {
  100% {
    transform: translateX(100%);
  }
}

.avatar {
  @include inter-bold;
  @include transition;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  background-color: $gray-30;
  color: $white;
  font-style: normal;
  font-weight: 500;
  font-size: 52px;
  line-height: 68px;
  letter-spacing: 0.01em;
  text-transform: uppercase;
  overflow: hidden;

  &.transparent {
    background-color: transparent;
  }

  .loading {
    width: inherit;
    height: inherit;
    transform: translateX(-100%);
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.25), transparent);
    animation: loading 1.3s infinite;
  }

  img {
    border-radius: 50%;
    height: 100%;
    width: auto;
  }
}

html:not([data-design-system='blaze']) {
  .blaze {
    border-radius: 33px;
    border: 1px solid var(--neutral-90);
  }
}

.emoji {
  svg {
    fill: $white;
  }
}

.logo {
  background-color: $white;
}

.svg-color-green60 {
  border: 2px solid $green-60;
  border-radius: 50%;
  path {
    fill: $green-60;
  }
}

.svg-color-blue60 {
  border: 2px solid $blue-60;
  border-radius: 50%;
  path {
    fill: $blue-60;
  }
}

.svg-color-navy60 {
  border: 2px solid $navy-60;
  border-radius: 50%;
  path {
    fill: $navy-60;
  }
}

.svg-color-gray60 {
  border: 2px solid $gray-60;
  border-radius: 50%;
  path {
    fill: $gray-60;
  }
}

.svg-color-gold60 {
  border: 2px solid $gold-60;
  border-radius: 50%;
  path {
    fill: $gold-60;
  }
}

.docEmoji {
  fill: $blue-40;
}
